import { jsx as _jsx } from "react/jsx-runtime";
import { Badge as ChakraBadge, createStylesContext, forwardRef, Icon, useStyleConfig, } from '@chakra-ui/react';
const [BadgeStylesProvider, useBadgeStyles] = createStylesContext('Badge');
export { useBadgeStyles };
export const Badge = (props) => {
    const styles = useStyleConfig('Badge', props);
    return (_jsx(BadgeStylesProvider, { value: { styles }, children: _jsx(ChakraBadge, { ...props }) }));
};
Badge.displayName = 'Badge';
export const BadgeLeftIcon = forwardRef((props, ref) => {
    const { styles } = useBadgeStyles();
    return (_jsx(Icon, { ref: ref, color: styles.accentColor, verticalAlign: "top", marginEnd: "0.25rem", ...props }));
});
BadgeLeftIcon.displayName = 'BadgeLeftIcon';
export const BadgeRightIcon = forwardRef((props, ref) => {
    const { styles } = useBadgeStyles();
    return (_jsx(Icon, { ref: ref, color: styles.accentColor, verticalAlign: "top", marginStart: "0.25rem", ...props }));
});
BadgeRightIcon.displayName = 'BadgeRightIcon';
